import { InconsistenciaEnderecoForm } from '../inconsistencia-endereco/InconsistenciaEnderecoForm';
import { InconsistenciaEnderecoResponse } from '../inconsistencia-endereco/InconsistenciaEnderecoResponse';
import { InconsistenciaEnderecoView } from '../inconsistencia-endereco/InconsistenciaEnderecoView';

export class InconsistenciaEnderecoConverter {
  public static inconsistenciaViewToInconsistenciaForm(
    inconsistenciaView: InconsistenciaEnderecoView
  ): InconsistenciaEnderecoForm {
    return {
      'cnpj': inconsistenciaView.cnpj,
      'companyId': inconsistenciaView.idEmpresa,
      'importation-id': inconsistenciaView.idImportacao,
      'new-address-id': inconsistenciaView.novoIdEndereco,
      'postal-code': inconsistenciaView.cep,
      'future-conflicts': inconsistenciaView.gravaBanco ? 'Y' : 'N',
    };
  }
  public static inconsistenciaResponseToInconsistenciaView(
    inconsistenciaResponse: InconsistenciaEnderecoResponse,
    numeroLinha : number
  ): InconsistenciaEnderecoView {
    return {
      cnpj: inconsistenciaResponse.id.cnpj,
      idEmpresa: inconsistenciaResponse.id.companyId,
      logradouro: inconsistenciaResponse.street,
      bairro: inconsistenciaResponse.district,
      cidade: inconsistenciaResponse.city,
      estado: inconsistenciaResponse.state,
      cep: inconsistenciaResponse.postalCode,
      processado: 'N',
      nomeEndereco: '',
      gravaBanco: false,
      numeroLinha: numeroLinha,
      novoIdEndereco: '0',
      idImportacao: inconsistenciaResponse.id.importationId,
    };
  }
}
